<template>
  <div>
    <Navigation />
    <div class="row tableUsers">
      <div v-if="addNewCategoryFlag" class="popUp-overlay"></div>
      <div v-show="addNewCategoryFlag" class="popUp-dialogCategories zHelper" style="width: 600px">
        <div class="col-md-12">
          <form>
            <div class="messages"></div>
            <div class="controls">
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group has-error has-danger">
                    <label class="floatLeft" for="name">Name Mk
                    <span v-bind:class="errorMsg ? 'error-infobox' : 'textDec'"
                  >*</span
                ></label>
                    <input
                      id="name"
                      v-model="name_mk"
                      type="text"
                      v-bind:class="errorMsg && !name_mk ? 'border-red' : 'border-none'"
                      name="name"
                      class="form-control"
                      placeholder
                      required="required"
                      data-error="error"
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group has-error has-danger">
                    <label class="floatLeft" for="name">Name Al
                    <span v-bind:class="errorMsg ? 'error-infobox' : 'textDec'"
                  >*</span
                ></label>
                    <input
                      id="name"
                      v-model="name_al"
                      type="text"
                      v-bind:class="errorMsg && !name_al ? 'border-red' : 'border-none'"

                      name="name"
                      class="form-control"
                      placeholder
                      required="required"
                      data-error="error"
                    />
                  </div>
                </div>
              </div>
                <div class="row">
                <div class="col-md-12">
                  <div class="form-group has-error has-danger">
                    <label class="floatLeft" for="name">Name En
                    <span v-bind:class="errorMsg ? 'error-infobox' : 'textDec'"
                  >*</span
                ></label>
                    <input
                      id="name"
                      v-model="name_en"
                      type="text"
                      name="name"
                      v-bind:class="errorMsg && !name_en ? 'border-red' : 'border-none'"

                      class="form-control"
                      placeholder
                      required="required"
                      data-error="error"
                    />
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <div class="form-group has-error has-danger">
                    <label class="floatLeft" for="is_active">Is active                 
                    <span v-bind:class="errorMsg ? 'error-infobox' : 'textDec'"
                  >*</span
                ></label>
                    <select
                      v-model="is_active"
                      name="is_active"
                      v-bind:class="errorMsg && !is_active ? 'border-red' : 'border-none'"
                      required
                      class="custom-select custom-select-sm form-control form-control-sm"
                    >
                      <option
                        v-for="(item, index) in statuses"
                        v-bind:value="item.id"
                      >
                        {{ item.text }}
                      </option>
                    </select>
                  </div>
                </div>
            
              </div>
               <div v-if="errorMsg" class="row">
                  <div class="col-md-12">
                    <div class="error-infobox">
                         {{ errorMsg }}
                    </div>
                  </div>
                </div>
              <div class="row floatLeft">
                <div class="col-md-12">
                  <input
                    @click.prevent="addNewCategory()"
                    type="submit"
                    class="btn btnDark btn-success btn-send pointer"
                    value="Submit"
                  />
                  <input
                    v-on:click="
                      addNewProvider  = false;
                      cancelActionNew();
                      errorMsg = '';
                    "
                    type="cancel"
                    class="btn btn-secondary pointer button-width-helper"
                    value="Cancel"
                  />
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
 <!--new part-->
       <div v-if="editCategoryFlag" class="popUp-overlay"></div>
      <div v-show="editCategoryFlag" class="popUp-dialogCategories zHelper" style="width: 600px">
       <div class="col-md-12">
          <form>
            <div class="messages"></div>
            <div class="controls">
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group has-error has-danger">
                    <label class="floatLeft" for="name">Name Mk <span
                        v-bind:class="errorMsg ? 'error-infobox' : 'textDec'"
                        >*</span
                      ></label>
                    <input
                      id="name"
                      v-model="name_mk"
                      v-bind:class="errorMsg && !name_mk ? 'border-red' : 'border-none'"
                      type="text"
                      name="name"
                      class="form-control"
                      placeholder
                      required="required"
                      data-error="error"
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group has-error has-danger">
                    <label class="floatLeft" for="name">Name Al <span
                        v-bind:class="errorMsg ? 'error-infobox' : 'textDec'"
                        >*</span
                      ></label>
                    <input
                      id="name"
                      v-model="name_al"   
                      v-bind:class="errorMsg && !name_al ? 'border-red' : 'border-none'"
                      type="text"
                      name="name"
                      class="form-control"
                      placeholder
                      required="required"
                      data-error="error"
                    />
                  </div>
                </div>
              </div>
                <div class="row">
                <div class="col-md-12">
                  <div class="form-group has-error has-danger">
                    <label class="floatLeft" for="name">Name En <span
                        v-bind:class="errorMsg ? 'error-infobox' : 'textDec'"
                        >*</span
                      ></label>
                    <input
                      id="name"
                      v-model="name_en"
                      v-bind:class="errorMsg && !name_en ? 'border-red' : 'border-none'"
                      type="text"
                      name="name"
                      class="form-control"
                      placeholder
                      required="required"
                      data-error="error"
                    />
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <div class="form-group has-error has-danger">
                    <label class="floatLeft" for="is_active">Is active <span
                        v-bind:class="errorMsg ? 'error-infobox' : 'textDec'"
                        >*</span
                      ></label>
                    <select
                      v-model="is_active"
                      name="is_active"
                      required
                      class="custom-select custom-select-sm form-control form-control-sm"
                    >
                      <option
                        v-for="(item, index) in statuses"
                        v-bind:value="item.id"
                      >
                        {{ item.text }}
                      </option>
                    </select>
                  </div>
                </div>
            
              </div>
             <div v-if="errorMsg" class="row">
                <div class="col-md-12">
                  <div class="error-infobox">
                    {{ errorMsg }}
                  </div>
                </div>
              </div>
              <div class="row floatLeft">
                <div class="col-md-12">
                  <input
                    @click.prevent="updateCategory()"
                    type="submit"
                    class="btn btnDark btn-success btn-send pointer"
                    value="Submit"
                  />
                  <input
                    v-on:click="
                      editCategoryFlag = false;
                      cancelActionEdit();
                      errorMsg = '';
                    "
                    type="cancel"
                    class="btn btn-secondary pointer button-width-helper"
                    value="Cancel"
                  />
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>

      <!--show subcategories here:-->
      <div v-if="showCategories" class="popUp-overlay"></div>
      <div v-show="showCategories" class="popUp-dialogScrollable zHelper" style="max-width: 1000px">
        <div class="col-md-12">
          <!-- table with categories-->
          <button
            @click="cancelAction"
            class="btn btn-secondary pointer floatRight1"
          >
            <v-icon class="cancel-icon">mdi-close</v-icon>
          </button>
          <div>
            <table
              class="table table-striped table-bordered dataTable dtr-inline"
              cellspacing="0"
              width="100%"
              role="grid"
            >
              <thead>
                <tr>
                  <th>Name Mk</th>
                  <th>Name Al</th>
                  <th>Name En</th>
                  <th>Is active</th>
                  <th> </th>
                </tr>
              </thead>
              <tbody>
                <!-- Table rows for existing categories -->
                <tr v-for="(category, index) of subcat" :key="index" :class="{ 'highlighted-row': category.editing }">
                  <td>
                    <input
                      type="text"
                      v-model="category.name_mk"
                      v-bind:class="{ 'border-red': errorMsg1 && category.name_mk.length === 0, 'border-none': !errorMsg1 || category.name_mk !== '' }"
                      :disabled="!category.editing"
                    />
                  </td>
                   <td>
                    <input
                      type="text"
                      v-model="category.name_al"
                      v-bind:class="{ 'border-red': errorMsg1 && category.name_al.length === 0, 'border-none': !errorMsg1 || category.name_al !== '' }"
                      :disabled="!category.editing"
                    />
                  </td>
                   <td>
                    <input id="input4e"
                      type="text"
                      v-model="category.name_en"
                     v-bind:class="{ 'border-red': errorMsg1 && category.name_en.length === 0, 'border-none': !errorMsg1 || category.name_en.length > 0 }"
                      :disabled="!category.editing"
                    />
                  </td>
                  <td>
                    <input
                      type="checkbox"
                      v-model="category.isActive"
                      :disabled="!category.editing"
                    />
                  </td>
                  <td>
                    <button
                      v-if="category.editing"
                      @click="saveCategory1(category)"
                      class="btn btn-success pointer"
                      style="background-color: rgb(18, 112, 92) !important;"
                    >
                      <v-icon style="color:white"
                        >mdi-map-marker-plus-outline</v-icon
                      >
                    </button>
                    <button
                      v-else
                      @click="editCategory(category)"
                      class="btn btn-secondary pointer"
                    >
                      <v-icon style="color:white"
                        >mdi-circle-edit-outline</v-icon
                      >
                    </button>
                  </td>
                </tr>
             <!-- Table row for adding new category -->
                <tr class="input-newlocation">
                  <td>
                    <input
                      v-model="newSubCat.name_mk"
                      placeholder="Name"
                      v-bind:class="errorMsg && newSubCat.name_mk.length < 1 ? 'border-red' : 'border-none'"

                    />
                  </td>
                   <td>
                    <input
                      v-model="newSubCat.name_al"
                      placeholder="Name"
                      v-bind:class="errorMsg && !newSubCat.name_al ? 'border-red' : 'border-none'"
                    />
                  </td>
                   <td>
                    <input
                      v-model="newSubCat.name_en"
                      placeholder="Name"
                      v-bind:class="errorMsg && !newSubCat.name_en ? 'border-red' : 'border-none'"
                    />
                  </td>
                  <td>
                    <input
                      type="checkbox"
                      v-model="newSubCat.isActive"
                      placeholder="is active"
                    />
                  </td>
                  <td>
                    <button class="btn btn-dark" @click="addCategory()" >
                      <v-icon style="color:white">mdi-plus-circle</v-icon>
                    </button>
                  </td>
                </tr>
             
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <!-- end new part-->

      <div class="col-md-12">
        <div class="card">
          <div class="card-body">
            <div class="toolbar">
              <!-- Here you can write extra buttons/actions for the toolbar -->
            </div>
            <div
              id="datatable_wrapper"
              class="dataTables_wrapper dt-bootstrap4"
            >
              <div class="row">
                <div class="col-sm-12 col-md-4 tableName tableHeading">
                  <a
                    href="#"
                    class="btn btn-round btn-icon btn-sm createNew mt-1"
                    title="Add new category"
                    v-on:click="addNew()"
                  >
                    <i class="fas fa-plus"></i>
                  </a>
                  Categories
                </div>
                <div class="col-sm-12 col-md-5">
                  <!-- Filter by type -->
                </div>

                <!-- Filter by Category -->

                <div class="col-sm-12 col-md-3">
                  <div id="datatable_filter" class="dataTables_filter">
                    <form
                      class="form-inline md-form floatRight searchDiv form-sm active-darkGreen-2 mt-3"
                    >
                      <input
                        v-model="searchCategory"
                        name="query"
                        v-on:keyup="filterCategoryResults()"
                        class="form-control borderNone form-control-sm mr-3"
                        type="text"
                        placeholder="Search"
                        aria-label="Search"
                      />
                      <i class="fas fa-search" aria-hidden="true"></i>
                    </form>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12 min-table-height">
                  <table
                    id="datatable"
                    class="table table-striped table-bordered dataTable dtr-inline"
                    cellspacing="0"
                    width="100px"
                    role="grid"
                    aria-describedby="datatable_info"
                  >
                    <thead>
                      <tr role="row">
                        <th
                          class="sorting_asc"
                          tabindex="0"
                          aria-controls="datatable"
                          rowspan="1"
                          colspan="1"
                          style="width: 100px"
                          aria-sort="ascending"
                          aria-label="Name: activate to sort column descending"
                          v-on:click="sortCategoryResults(1)"
                        >
                          Category
                        </th>

                        <th
                          class="sorting_asc"
                          tabindex="0"
                          aria-controls="datatable"
                          rowspan="1"
                          colspan="1"
                          style="width: 100px"
                          aria-sort="ascending"
                          aria-label="Actions: activate to sort column ascending"
                          v-on:click="sortCategoryResults(2)"

                        >
                          Is Active
                        </th>

                   
                        <th
                          class="disabled-sorting text-right sorting"
                          tabindex="0"
                          aria-controls="datatable"
                          rowspan="1"
                          colspan="1"
                          style="width: 80px"
                          aria-label="Actions: activate to sort column ascending"
                        >
                          Actions
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        role="row"
                        v-bind:key="index"
                        v-for="(provider, index) in provider_voucher_stats"
                        v-bind:class="[
                          index % 2 == 0 || index == 0 ? 'even' : 'odd',
                        ]"
                      >
                        <td tabindex="0" class="sorting_1">
                          {{ provider.name_mk }}
                        </td>
                       
                        <td tabindex="0" class="sorting_1">
                          {{ provider.isActive ? 1 : 0 }}                        
                        </td>
                        <td class="text-right" style="width: 13%;">
                          <div class="actions_on_user">
                           <a
                              href="#"
                              class="btn btn-round btn-edit btn-icon btn-sm edit"
                              @click.prevent="editParentCategory(provider.id)"
                              id="edit"
                            >
                              <i class="far fa-edit"></i>
                            </a>
                            <label class="activity_label" for="edit"
                              >Edit</label
                            >
                          </div>
                          <div class="actions_on_user">
                                <a
                              href="#"
                              class="btn btn-round btn-edit btn-icon btn-sm edit"
                              @click.prevent="getCategories(provider.id)"
                              id="categories"
                            >
                              <i class="far fa-eye"></i>
                            </a>
                            <label class="activity_label" for="categories"
                              >Subcategories</label
                            >
                          </div>

                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <pagination
                :meta_data="meta_data_category"
                v-on:next="fetchCategoryResults"
              ></pagination>
            </div>
          </div>
          <!-- end content-->
        </div>
        <!--  end card  -->
      </div>
      <!-- end col-md-12 -->
    </div>
  </div>
</template>
<script>
import Navigation from "@/views/Navigation.vue";
import axios from "axios";
import Pagination from "@/components/Pagination.vue";
import store from "./../store/index";
export default {
  components: {
    Navigation,
    Pagination,
  },
  data() {
    return {
      extension_url: "",
      addNewCategoryFlag: false,
      provider_voucher_stats: null,
      searchCategory: null,
      orderCategory: null,
      sortCategory: null,
      dirCategory: null,
      name_mk: null,
      name_en:null,
      name_al: null,
      isActive: false,
      parentId: null,
      is_active: false,
      editProvider: false,
      showCategories: false,
      editing: false,
      idParent: null,
      nameData: null,
      selected_type: null,
      provider_id: null,
      scanner_type: null,
      subcat:[],
      newSubCat: {
        name_mk: "",
        name_al: "",
        name_en: "",
        isActive: false,
        idNaParent: null
      },
      statuses: [
        {
          id: 1,
          text: "Active",
        },
        {
          id: 0,
          text: "Non-active",
        },
      ],
      meta_data_category: {
        last_page: null,
        current_page: 1,
        prev_page_url: null,
        perpage: 5,
        total: 0,
      },
      editCategoryFlag: false,
      errorMsg: "",
      errorMsg1: "",
    };
  },
  mounted() {
    this.setURL();
    this.fetchCategoryResults(
      this.meta_data_category.current_page,
      this.meta_data_category.perpage,
      this.searchCategory,
      this.orderCategory,
      this.sortCategory
    );
    document.addEventListener("keydown", this.onEscapeKey);

  },
  destroyed(){
        document.removeEventListener("keydown", this.onEscapeKey);
  },
  methods: {
    setURL() {
      if (store.state.ENV === "dev") {
        this.extension_url = store.state.EXTENSION_DEV_URL;
      } else if (store.state.ENV === "test") {
        this.extension_url = store.state.EXTENSION_TEST_URL;
      } else {
        this.extension_url = store.state.EXTENSION_PROD_URL;
      }
    },
    onEscapeKey(event){
      if(event.key === 'Escape' && this.addNewCategoryFlag){
        this.cancelActionNew();
      }
      if(event.key === 'Escape' && this.showCategories){
        this.cancelAction();
      }
      if(event.key === 'Escape' && this.editCategoryFlag){
        this.cancelActionEdit();
      }
    },
    async getCategories(id){

        await axios
        .get(
          `${this.extension_url}api/Category/GetAllLocationsByCategory?id=${id}`,
          {
            headers: { Authorization: localStorage.getItem("accessToken") },
            params: {
              id: id,
            },
          }
        )
        .then((res) => {
          this.subcat = res.data;
          if(this.subcat[0] === undefined){
            this.$data.showCategories = true;
            this.idParent = id;
          }else{
          this.idParent = this.subcat[0].parentId;
       //   console.log(res.data);
          this.$data.showCategories = true;

          this.subcat.map((category) => {
            category.editing = false;
          });
          }
        });
    },
     async getEditingForm(id) {
      await axios.get(
          `${this.extension_url}api/Category/${id}`,
          {
          headers: { Authorization: localStorage.getItem("accessToken") },
          params: {
            id: id,
          },
        })
        .then((res) => {
          this.parentId = res.data.id;
          this.name_mk = res.data.name_mk;
          this.name_en = res.data.name_en;
          this.name_al = res.data.name_al;
          this.is_active = res.data.isActive ? 1 : 0;
        })
        .catch((error) => {
          console.error("Error fetching categories data:", error);
        });
    },
    editCategory(category) {
      category.editing = !category.editing;
      this.subcat = JSON.parse(JSON.stringify(this.subcat));
    },

    // getCategories(id, name) {
    // //   this.idData = id;
    // //   this.nameData = name;
    //   this.$data.showCategories = true;
    //   this.getCategories1(id);
    // },
    async saveCategory(category) { //save edited category
    try{            
      const previous_names = await axios.get(
          `${this.extension_url}api/Category/GetAllCategoriesInProviders`,
          {
            headers: { Authorization: localStorage.getItem("accessToken") },
          }
      );
      var previous_names_all = [];
      previous_names.data.forEach((name) => {
          previous_names_all.push(name.name_mk);
      });
      previous_names.data.forEach((name) => {
          previous_names_all.push(name.name_en);
      });
      previous_names.data.forEach((name) => {
          previous_names_all.push(name.name_al);
      });
     previous_names.data.forEach((name) => {
          previous_names_all.push(true);
      });
      const currCategory= await axios.get(
          `${this.extension_url}api/Category/${category.id}`,
          {
            headers: { Authorization: localStorage.getItem("accessToken") },
          }
      ); 
        var currlistnames= [];  
    currlistnames.push(currCategory.data.name_mk);
    currlistnames.push(currCategory.data.name_en);
    currlistnames.push(currCategory.data.name_al);
      if( previous_names_all.includes(category.name_mk) || previous_names_all.includes(category.name_en) || previous_names_all.includes(category.name_al) ){
      if( currlistnames.includes(category.name_mk) || currlistnames.includes(category.name_en) || currlistnames.includes(category.name_al)) 
      { 
          console.log("ok");
      } else{
        this.$toasted
            .show("Подкатегорија со тоа име веќе постои. ", { type: "error" })
            .goAway(2000);
          return;
      }
    }
     const regexMkd = /[\u0400-\u04FF]/;
    if (regexMkd.test(category.name_en) ||regexMkd.test(category.name_al) ) {
        this.errorMsg = "Името на албански и англиски треба да биде на латиница.";
    }
      
   
     
      const response = await axios.put(
          `${this.extension_url}api/Category/${category.id}`,
          {
            name_mk: category.name_mk,
            name_al: category.name_al,
            name_en: category.name_en,
            IsActive: category.isActive,
            ParentId: category.parentId
          },
        {
        headers: {
             Authorization: localStorage.getItem("accessToken"),
            },
        }   
        );
        category.editing = false;
      this.fetchCategoryResults(
        this.meta_data_category.current_page,
        this.meta_data_category.perpage,
        this.searchProvider,
        this.orderProvider,
        this.sortProvider
      );
        if (response && response.data) {
          delete category.editing; // Remove editing flag
        }
      } catch (error) {
        if(!category.name_mk.trim() || !category.name_en.trim() || !category.name_al.trim()) {
          if(category.parentId != null){ // subcategory
            this.errorMsg1 = "Името на подкатегоријата не може да биде празно";
          }else{
            this.errorMsg = "Името на категоријата не може да биде празно";
          }
        }
        
        console.log("Error saving category: ", error);
      }
  },
  async saveCategory1(category) { //save edited subcategory 
    try{            
      const previous_names = await axios.get(
          `${this.extension_url}api/Category/GetAllCategoriesInProviders`,
          {
            headers: { Authorization: localStorage.getItem("accessToken") },
          }
      );
      var previous_names_all = [];
      previous_names.data.forEach((name) => {
          if(name.parentId == category.parentId)
          {
          previous_names_all.push(name.name_mk);
          previous_names_all.push(name.name_en);
          previous_names_all.push(name.name_al);
          }
      });
     //console.log("names", previous_names_all);
      
      const currCategory= await axios.get(
          `${this.extension_url}api/Category/${category.id}`,
          {
            headers: { Authorization: localStorage.getItem("accessToken") },
          }
      ); 
    const currNames = [
  currCategory.data.name_mk,
  currCategory.data.name_en,
  currCategory.data.name_al
];

  if (currNames.some(name => previous_names_all.includes(name))) { //remove current subcat names from previousnames list
    previous_names_all = previous_names_all.filter(name => !currNames.includes(name));
  }


    if( previous_names_all.includes(category.name_mk) || previous_names_all.includes(category.name_en) || previous_names_all.includes(category.name_al) ){

        this.$toasted
            .show("Подкатегорија со тоа име веќе постои.", { type: "error" })
            .goAway(2000);
          return;
    }
     const regexMkd = /[\u0400-\u04FF]/;
    if (regexMkd.test(category.name_en) ||regexMkd.test(category.name_al) ) {
        this.errorMsg = "Името на албански и англиски треба да биде на латиница.";
    }
           
      const response = await axios.put(
          `${this.extension_url}api/Category/${category.id}`,
          {
            name_mk: category.name_mk,
            name_al: category.name_al,
            name_en: category.name_en,
            IsActive: category.isActive,
            ParentId: category.parentId
          },
        {
        headers: {
             Authorization: localStorage.getItem("accessToken"),
            },
        }   
        );
        category.editing = false;
      this.fetchCategoryResults(
        this.meta_data_category.current_page,
        this.meta_data_category.perpage,
        this.searchProvider,
        this.orderProvider,
        this.sortProvider
      );
        if (response && response.data) {
          delete category.editing; // Remove editing flag
        }
      } catch (error) {
        if(!category.name_mk.trim() || !category.name_en.trim() || !category.name_al.trim()) {
          if(category.parentId != null){ // subcategory
            this.errorMsg1 = "Името на подкатегоријата не може да биде празно";
          }else{
            this.errorMsg = "Името на категоријата не може да биде празно";
          }
        }
        
        console.log("Error saving category: ", error);
      }
  },
  editParentCategory(id) {
      this.editCategoryFlag = true;
      this.idData = id;
      this.getEditingForm(id);
  },
  async updateCategory(){ //update edited parent category  
    var post_data = {
          id: this.idData,
          name_mk: this.name_mk,
          name_en: this.name_en,
          name_al: this.name_al,
          isActive: this.is_active
    }
    const currCategory= await axios.get(
          `${this.extension_url}api/Category/${this.idData}`,
          {
            headers: { Authorization: localStorage.getItem("accessToken") },
          }
      );
    const previous_names = await axios.get(
          `${this.extension_url}api/Category/GetAllCategoriesInProviders`,
          {
            headers: { Authorization: localStorage.getItem("accessToken") },
          }
        ); 
   
    var previous_names_all = [];
    previous_names.data.forEach((name) => {
          previous_names_all.push(name.name_mk);
        });
    previous_names.data.forEach((name) => {
          previous_names_all.push(name.name_en);
        });
    previous_names.data.forEach((name) => {
          previous_names_all.push(name.name_al);
        });

    var currlistnames= [];  
    currlistnames.push(currCategory.data.name_mk);
    currlistnames.push(currCategory.data.name_en);
    currlistnames.push(currCategory.data.name_al); 
   // console.log("currlistnames: " , currlistnames);
    const regexMkd = /[\u0400-\u04FF]/;
    if (regexMkd.test(post_data.name_en) ||regexMkd.test(post_data.name_al) ) {
        this.errorMsg = "Името на албански и англиски треба да биде на латиница.";
    }else{
    if (!post_data.name_mk.trim() || !post_data.name_en.trim() || !post_data.name_al.trim()) {  
       this.errorMsg = "Името на категоријата не може да биде празно";
    }else{
    if( previous_names_all.includes(post_data.name_mk) || previous_names_all.includes(post_data.name_en) || previous_names_all.includes(post_data.name_al) ){
      if( currlistnames.includes(post_data.name_mk) || currlistnames.includes(post_data.name_en) || currlistnames.includes(post_data.name_al)) 
      { 
          console.log("ok");
      } else{
        this.$toasted
            .show("Категорија со тоа име веќе постои. ", { type: "error" })
            .goAway(2000);
          return;
      }
    }
    	
    this.saveCategory(post_data);
    this.editCategoryFlag = false;
    this.fetchCategoryResults(
        this.meta_data_category.current_page,
        this.meta_data_category.perpage,
        this.searchProvider,
        this.orderProvider,
        this.sortProvider
    );
    this.cancelActionEdit();
   }
  }
    },
    async addCategory(){ // add subcategory 
      const parent = this.idParent;
      this.errorMsg = "";
      
      const previous_names = await axios.get(
          `${this.extension_url}api/Category/GetAllCategoriesInProviders`,
          {
            headers: { Authorization: localStorage.getItem("accessToken") },
          }
        );
      var previous_names_all = [];
      previous_names.data.forEach((name) => {
         if(name.parentId == parent)
          {
          previous_names_all.push(name.name_mk);
          previous_names_all.push(name.name_en);
          previous_names_all.push(name.name_al);
          }

        });

     
    const regexMkd = /[\u0400-\u04FF]/;
    if (regexMkd.test(this.newSubCat.name_en) ||regexMkd.test(this.newSubCat.name_al) ) {
        this.errorMsg = "Името на албански и англиски треба да биде на латиница.";
         this.$toasted
            .show(this.errorMsg, { type: "error" })
            .goAway(2000);
    }
    if (previous_names_all.includes(this.newSubCat.name_mk) || previous_names_all.includes(this.newSubCat.name_en) || previous_names_all.includes(this.newSubCat.name_al) ) { 
          this.$toasted
            .show("Подкатегорија со тоа име веќе постои. ", { type: "error" })
            .goAway(2000);
          return;
      }
      if (
        this.newSubCat.name_mk && this.newSubCat.name_en && this.newSubCat.name_al) {
        const postData = {
          name_mk: this.newSubCat.name_mk,
          name_al: this.newSubCat.name_al,
          name_en: this.newSubCat.name_en,
          IsActive: this.newSubCat.isActive,
          ParentId: this.idParent
        };
        await axios
          .post(`${this.extension_url}api/Category/CreateCategory`,
          postData,
          {
           headers: {
                Authorization: localStorage.getItem("accessToken"),
            },
           }
          )
          .then(async (response) => {
            if (response) {
             // console.log("Category added successfully:", response.data);
              await this.getCategories(postData.ParentId);
              this.$toasted
                .show("Подкатегоријата е успешно додадена", { type: "success" })
                .goAway(2000);
            }
          })
          .catch((error) => {
            this.errorMsg = error.response.data;
            console.log(error.response.data);
          });
        }else{
        if(this.newSubCat.name_mk === '' || this.newSubCat.name_al === '' || this.newSubCat.name_en === '' ){
          this.errorMsg = "Category can not be empty";
          return;
        }
      }
      // Clear input fields
      this.newSubCat.name_mk = "";
      this.newSubCat.name_al = "";
      this.newSubCat.name_en = "";
      this.newSubCat.isActive = false;
      this.errorMsg = "";

    },
    addNew() {
      this.$data.addNewCategoryFlag = true;
      this.errorMsg = "";
    },

    // sort
    sortCategoryResults(order) {
      this.dirCategory++;
      this.orderCategory = order;

      if (this.dirCategory % 2 == 0) this.sortCategory = "desc";
      else this.sortCategory = "asc";
      this.fetchCategoryResults(
        this.meta_data_category.current_page,
        this.meta_data_category.perpage,
        this.searchCategory,
        this.orderCategory,
        this.sortCategory
      );
    },

    async addNewCategory() { //add new parent category
    this.errorMsg = "";
      var post_data = {
          name_mk: this.name_mk,
          name_al: this.name_al,
          name_en: this.name_en,
          isActive: this.is_active,
          parentId: null,
        
      };
      //get all data from db
      const previous_names = await axios.get(
          `${this.extension_url}api/Category/GetAllCategoriesInProviders`,
          {
            headers: { Authorization: localStorage.getItem("accessToken") },
          }
      );
      var previous_names_all = [];
      previous_names.data.forEach((name) => {
          previous_names_all.push(name.name_mk);
        });
      previous_names.data.forEach((name) => {
          previous_names_all.push(name.name_en);
        });
      previous_names.data.forEach((name) => {
          previous_names_all.push(name.name_al);
        });

      if (previous_names_all.includes(post_data.name_mk) || previous_names_all.includes(post_data.name_en) || previous_names_all.includes(post_data.name_al) ) { 
         this.errorMsg = "Категорија со тоа име веќе постои. ";
          return;
      }
       const regexMkd = /[\u0400-\u04FF]/;
    if (regexMkd.test(post_data.name_en) ||regexMkd.test(post_data.name_al) ) {
        this.errorMsg = "Името на албански и англиски треба да биде на латиница.";
    }
      axios.defaults.headers.common["Authorization"] = localStorage.getItem(
        "accessToken"
      );

      axios
        .post(`${this.extension_url}api/Category/CreateCategory`, post_data)
        .then((response) => {
          this.addNewCategoryFlag = false;
          this.fetchCategoryResults(
            this.meta_data_category.current_page,
            this.meta_data_category.perpage,
            this.searchProvider,
            this.orderProvider,
            this.sortProvider
          );
           this.name_mk = "";
           this.name_al = "";
           this.name_en = "";
           
           this.is_active = null;
          this.errorMsg = "";
          this.$toasted
                .show("Категоријата е успешно додадена", { type: "success" })
            .goAway(2000);
        })
        .catch((error) => {
        //  console.log("error is: ",error.response.data);
          if (error && error.response.data.title.includes("One or more validation errors occurred")) {
              this.errorMsg = error.response.data.message;
              this.$toasted
                .show(this.errorMsg, {
                  type: "error",
              })
              .goAway(2000);
          this.errorMsg = "Please fill all the required fields";     
            }
                
        });
    },

    // filter
    filterCategoryResults() {
      this.fetchCategoryResults(
        this.meta_data_category.current_page,
        this.meta_data_category.perpage,
        this.searchCategory,
        this.orderVoucher,
        this.sortCategory
      );
      this.meta_data_category.current_page = 1;
    },
    // fetch
    fetchCategoryResults(
      page = this.meta_data_category.current_page,
      perpage = this.meta_data_category.perpage,
      search = this.searchCategory,
      order = this.orderCategory,
      sort = this.sortCategory,
      total = this.meta_data_category.total
    ) {
      axios
        .get(`${this.extension_url}api/Category/GetAllCategories`,           {
            headers: { Authorization: localStorage.getItem("accessToken") },
            params: {
              page,
              perpage,
              search,
              order,
              sort,
              total,
            },
          })
        .then((res) => {
          this.provider_voucher_stats = res.data.data; //.results.provider_stats;
          var pagination = res.data.pagination;
          this.meta_data_category.last_page = pagination.last_page;
          this.meta_data_category.current_page = pagination.current_page;
          this.meta_data_category.prev_page_url = pagination.prev_page_url;
          this.meta_data_category.perpage = pagination.perpage;
          this.meta_data_category.search = pagination.search;
          this.meta_data_category.total = pagination.total;

        });
    },

    clearFormCategories() {
      this.newSubCat.name_mk = "";
      this.newSubCat.name_al = "";
      this.newSubCat.name_en = "";
      this.newSubCat.isActive = false;
    },
    cancelAction() {
      this.showCategories = false;
      this.clearFormCategories();
      this.errorMsg = "";
    },
    cancelActionEdit(){
      this.editCategoryFlag = false;
      this.name_mk = "";
      this.name_al = "";
      this.name_en = ""; 
      this.is_active = null; 
      this.errorMsg = "";
    },
    cancelActionNew(){
      this.addNewCategoryFlag = false;
      this.name_mk = "";
      this.name_al = "";
      this.name_en = "";
      this.isActive = false;
      this.errorMsg = "";
    }
  },
};
</script>

<style src="../css/style.css"></style>
